
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
    name: "PageCopyright",
    props: {
        artists: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
    },
    setup(props) {
        const copyright = computed(() => {
            if (!props.artists.length) return "";
            const visda = props.artists.map((a) => `© ${a} / VISDA`);
            return visda.length > 1 ? visda.join(", ") : visda[0];
        });

        return { copyright };
    },
});
